module.exports = __webpack_public_path__ + "static/media/Clock-7.1s-100px.d5a14a25.svg";